export function getHtml(val) {
  return `<div class="sk-loading-wrap">
        <div class="sk-loading-row">
            <div class="sk-loading-spin">
                <span class="sk-loading-item"></span>
                <span class="sk-loading-item"></span>
                <span class="sk-loading-item"></span>
                <span class="sk-loading-item"></span>
            </div>
        </div>

        <div class="sk-loading-text">${val || 'Loading...'}</div>
    </div>`;
}